var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import ReactDOM from "react-dom";
import { classNames } from "@bookingcom/bui-core/utilities/classNames";
import { useFlyoutContext } from "./Flyout.context.js";
import styles from "@bookingcom/bui-core/css/_base/Flyout.module.css";
import useIsomorphicLayoutEffect from "../../../hooks/useIsomorphicLayoutEffect.js";
var FlyoutContent = function (props) {
    var children = props.children, className = props.className, attributes = props.attributes;
    var _a = React.useState(false), mounted = _a[0], setMounted = _a[1];
    var _b = useFlyoutContext(), flyout = _b.flyout, id = _b.id, flyoutElRef = _b.flyoutElRef, handleTransitionEnd = _b.handleTransitionEnd, handleMouseEnter = _b.handleMouseEnter, handleMouseLeave = _b.handleMouseLeave, contentClassName = _b.contentClassName, contentAttributes = _b.contentAttributes, flyoutContainerRef = _b.flyoutContainerRef, follow = _b.follow, disableAnimation = _b.disableAnimation;
    var positionStyles = flyout.styles, active = flyout.active, visible = flyout.visible, position = flyout.position;
    useIsomorphicLayoutEffect(function () {
        setMounted(true);
    }, []);
    if (!active)
        return null;
    var contentClassNames = classNames(styles.content, visible && styles["content--visible"], position && styles["content--position-".concat(position)], follow && styles["content--follow"], disableAnimation === true && styles["content--disable-animation"]);
    // className is applied to inner element because it has the transform and is treated like a real root element
    var innerClassNames = classNames(styles.inner, className, contentClassName);
    var content = (React.createElement("div", { className: contentClassNames, style: positionStyles, ref: flyoutElRef, id: id, onTransitionEnd: handleTransitionEnd, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave },
        React.createElement("div", __assign({}, contentAttributes, attributes, { className: innerClassNames }), typeof children === "function"
            ? children({ position: position })
            : children)));
    return (mounted &&
        ReactDOM.createPortal(content, (flyoutContainerRef === null || flyoutContainerRef === void 0 ? void 0 : flyoutContainerRef.current) || document.body));
};
export default FlyoutContent;
